import { Tab } from "@customType/Tab";
import { MydWorldLogo } from "src/assets/svgs";
import { cls } from "src/theme/colors";
import styled from "styled-components";

interface HeaderProps {
  tab: Tab;
}

const NAV_TABS: { tab: Tab; label: string }[] = [
  { tab: "myd", label: "마이디" },
  { tab: "mystock", label: "마이주식" },
];

export default function Header({ tab }: HeaderProps) {
  return (
    <>
      <S.Container>
        <S.Content>
          <S.Logo href="/" aria-label="myd.world 홈">
            <MydWorldLogo />
          </S.Logo>
          <S.Nav>
            {NAV_TABS.map(({ tab: navTab, label }) => (
              <a key={navTab} href={`#${navTab}`} aria-current={tab === navTab ? "page" : undefined}>
                {label}
              </a>
            ))}
          </S.Nav>
        </S.Content>
      </S.Container>
      <S.UnderNeath />
    </>
  );
}

const S = {
  Container: styled.header`
    width: 100%;
    color: ${cls.mainBlack};
    text-align: right;
    font-size: 18px;
    font-family: Noto Sans KR;
    background: ${cls.white};
    position: absolute;
    top: 0;
    left: 0;
  `,
  Content: styled.div`
    width: calc(100% - (240 * 2) px);
    height: 121px;
    margin: 0 240px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  Logo: styled.a`
    display: block;
  `,
  Nav: styled.nav`
    a {
      position: relative;
      /* 한글은 줄 가운데보다 조금 아래에 그려져서, 로고 글자와 높이가 맞도록 살짝 올린다. */
      top: -2.5px;
      margin-left: 45px;
      /* 굵은 로고 옆에서 가늘어 보이지 않게 굵기는 로고와 비슷하게, 크기는 로고 글자보다 조금 작게 잡는다. (화면 맞춤 배율로 줄어 1440px 화면에서 약 16px) */
      font-size: 25px;
      font-weight: 800;
      letter-spacing: -0.75px;
      padding-bottom: 8px;
      color: ${cls.mainBlack};
      /* 글자 크기만큼만 눌리면 작은 화면에서 누르기 어려워서, 보이는 모양은 그대로 두고 눌리는 영역만 넓힌다. */
      &::before {
        position: absolute;
        top: -16px;
        right: -16px;
        bottom: -12px;
        left: -16px;
        content: "";
      }
      /* 올려 둔 탭은 옅은 선, 지금 보고 있는 탭은 로고와 같은 파란 선으로 구분한다. 선은 글자 획과 비슷한 굵기로 맞춘다. */
      &:hover {
        border-bottom: 4px solid ${cls.gray4};
      }
      &[aria-current="page"] {
        border-bottom: 4px solid ${cls.mainBlue5};
      }
    }
  `,
  UnderNeath: styled.div`
    width: 100%;
    height: 121px;
  `,
};
